// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedUser: null,
  isps: [],
};

const usersISP = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_USER':
      return {...state, allData: action.data, selectedUser: null};
    case 'GET_DATA_ISP':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case 'GET_USER':
      return {...state, selectedUser: action.selectedUser};
    case 'ADD_USER':
      return {...state};
    case 'DELETE_USER':
      return {...state};
    case 'GET_ALL_DATA_ISP_X':
      return {...state, isps: action.data};
    default:
      return {...state};
  }
};
export default usersISP;
